module.exports = __webpack_public_path__ + "static/media/logo.b19c54ff.svg";